<script>
    import ClientLayout from '@/Layouts/Client';
    export default {
        layout: ClientLayout,
    }
</script>

<script setup>
    import PrimaryButton from '@/components/client/Buttons/PrimaryButton';
    import { step } from '@/Layouts/ClientUtils';
    import { inject } from 'vue';
    const isMobile = inject('$isMobile');

    step.name = 'welcome';
</script>

<template>
    <div>
        <div class="flex flex-col md:flex-row md:h-12 items-center mb-6 md:mb-2">
            <!-- <h2 class="text-2xl text-red font-avertaBold"><span class="uppercase">Mina sidor Företag</span> / <span class="font-averta">Kampanjer</span></h2> -->

            <h2 class="text-md md:text-2xl text-red font-avertaBold"><span class="uppercase">Mina sidor Företag</span></h2>
        </div>

        <div class="bg-white rounded-md p-6 shadow-sm text-center">
            <h2 class="text-3xl mb-5 font-averta text-red">Hejsan och välkommen till "Mina sidor Företag"!</h2>

            <p class="mb-2 inline-block font-averta">Härifrån sköter du på egen hand din företagssida och dina erbjudanden på familjekortet.se. </p>

            <p class="mb-2 block font-averta">Är det första gången du besöker Mina sidor Företag? Då är det bara att luta dig tillbaka och åka med. Vi kommer automagiskt att skicka dig mellan de olika stegen.</p>

            <p class="mb-2 block font-averta">Vi har försökt att göra det så lätt som möjligt och på de flesta ställen så hittar du tips och råd under <icon name="info" style="display: inline;"></icon>. Den klickar du på när du vill ha tips och råd! Skulle du ändå stöta på problem, så tveka inte att maila, ringa eller chatta med oss!</p>

            <div class="flex justify-center">
                    <primary-button
                    v-if="!step.isCompleted()"
                    @click="step.complete()"
                    :loading="step.isCompleting"
                    class="mt-2"> Då kör vi!</primary-button>
            </div>
        </div>
    </div>
</template>
